import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "ancestor"
    }}>{`Ancestor`}</h1>
    <p>{`A structure identifying a document that was copied or placed into the current document.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`The namespace URI is `}<a parentName="p" {...{
            "href": "http://ns.adobe.com/photoshop/1.0/"
          }}>{`http://ns.adobe.com/photoshop/1.0/`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The preferred namespace prefix is photoshop`}</p>
      </li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Name`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Description`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Type`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`photoshop:AncestorID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The unique identifier of a document`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../index.md#uri"
            }}>{`URI`}</a></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      